import React, { useContext } from 'react'

export const ProfileContext = React.createContext({
  profile: { type: null, id: null, content: null },
  setProfile: () => {},
})

export const useProfile = () => useContext(ProfileContext)
